{/* Auto-generated icon - do not edit */}
import React from 'react'

interface PauseIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const PauseIcon = React.forwardRef<SVGSVGElement, PauseIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 72 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M12.0077 8.37112C11.9566 6.77491 11.7288 5.18929 11.3282 3.64309C11.1294 2.7254 10.6164 1.90545 9.87752 1.32422C9.13866 0.742974 8.2199 0.436722 7.27927 0.458077C5.32514 0.534127 3.95726 1.73269 3.42509 3.83154C3.0139 5.59723 2.7757 7.39865 2.7138 9.21033C2.60436 11.3423 2.49016 13.475 2.37117 15.6083C2.00901 22.2324 1.63449 29.0828 1.5003 35.8298C1.22216 49.8347 1.1746 63.9501 1.16809 77.1186C1.21662 84.7236 2.18926 92.2948 4.06474 99.6665C4.36267 100.54 4.84841 101.339 5.48799 102.006C5.81368 102.411 6.15632 102.831 6.50155 103.324C6.56319 103.412 6.64531 103.484 6.74093 103.534C6.83654 103.584 6.94282 103.61 7.05067 103.61H7.06566C7.17602 103.607 7.28399 103.578 7.38001 103.523C7.47603 103.469 7.55712 103.392 7.61607 103.299C7.96586 102.746 8.23814 102.36 8.44137 102.072C8.74986 101.728 8.96019 101.308 9.0504 100.856C9.70178 93.9881 10.2463 87.921 10.7192 82.3037C12.0636 66.3429 12.1601 50.0933 12.2532 34.3776C12.2745 30.8208 12.3003 27.2638 12.3307 23.7066C12.3763 19.0559 12.2128 14.333 12.0559 9.76543L12.0077 8.37112Z" fill={color}/>
<path d="M68.9361 3.79136C68.5004 2.66166 66.4889 2.19238 65.5083 2.19238C64.4915 2.19238 63.2598 3.36819 63.0032 4.29314C62.5338 6.04853 62.2684 7.85203 62.2124 9.668L61.9277 16.753C61.4418 28.8196 60.9389 41.2977 60.5983 53.5762C60.3449 62.708 60.083 72.1499 61.5441 81.6022C62.413 87.2241 63.6161 92.7731 64.786 97.9308L64.8224 98.092C65.1162 99.4148 65.6087 101.628 69.0723 101.657H69.0782C69.2553 101.657 69.4253 101.587 69.551 101.462C69.6768 101.337 69.7471 101.167 69.7478 100.99C69.7478 99.5422 69.736 98.118 69.725 96.7114C69.6996 93.5596 69.6755 90.5819 69.7771 87.5692C69.8644 84.9887 70.0324 82.3627 70.1959 79.8232C70.3829 76.919 70.5757 73.9159 70.6519 70.9532C70.904 60.7158 71.2029 47.2282 71.2778 33.6699C71.3156 26.7682 71.1391 19.3595 70.7385 11.0187C70.517 8.53089 69.9087 6.09255 68.9361 3.79136Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="71" height="104" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

PauseIcon.displayName = 'PauseIcon'
